export default __webpack_public_path__ + "static/media/outlook-image.72f3e989.png";